module.exports = __webpack_public_path__ + "static/media/logout_image.42ea0265.png";